
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorPointerIcon as ObiCursorPointerIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-pointer-icon.js';
 
 
 

 
 export const ObiCursorPointerIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-pointer-icon',
   elementClass: ObiCursorPointerIconElement,
   events: {
     
   }
  });
 
 